(function (window) {
  // Matches on 1/1/1 or 1-1-1
  var dateRegex = new RegExp(/(\d+)[/|-](\d+)[/-](\d+)/);
  // Greedily matches all non-numeric, non-space characters that are no '-' or '/'.
  const nonNumericRegex = new RegExp(/[^0-9\s\-:]+/);
  // YYYY-MM-DD or YYYY:MM:DD ie '1234/67/90'
  const longestPlausibleDateLength = 10;
  const nonNumericCharacterThreshold = 5;

  /**
   * Checks the given data for euro style dates (day/month/year) and converts
   * them to year-month-day. This is done so that the client can handle the
   * dates. JavaScript can't parse d/m/y or d-m-y. Using a big of regex and a
   * light algo we check if a column of data looks like a euro date and if so
   * we convert them all. If *any* do not look like a euro date we do not
   * convert the column of dates.
   *
   * @param {array} rawData Should be an array of arrays. Each array in the
   * array represents a row of data.
   *
   * @param {boolean} hasHeader A true or false value to tell the algo if the
   * first row is a header row. If true it will NOT be factored in. For
   * example if every cell in the column looks like a euro date *except* the
   * first row and this is true it'll ignore this fact and the dates will be
   * converted but the first row wont. If this is false it will NOT convert
   * the dates at all.
   *
   * @return {array} Will return a cloned array. This may be identical to the
   * array given if no dates were found or it will be the same array with
   * euro dates converted.
   *
   * @constructor
   */
  var BatchGeoEuroDateConverter = function (rawData, hasHeader) {
    var data = $.extend(true, [], rawData);

    // This tracks the status of each cell. There's 3 values that go here:
    // null = the default, it means we don't know if its a euro date or not
    // false = we know for sure this is not a euro date
    // true = we know for sure this is a euro date
    var cellTracker = [];
    for (let row = 0; row < data.length; row++) {
      // Setup a new array for the row to push the cell values into
      cellTracker.push([]);
      // For each cell
      for (let cell = 0; cell < data[row].length; cell++) {
        cellTracker[row][cell] = null;

        // Never count the first row as it's the header!
        if (hasHeader && row === 0) continue;

        // If the cell is empty just leave it null so that it doesn't
        // alter the results one way or the other.
        if (data[row][cell] === "") continue;

        // Attempts to reduce false positives
        if (
          // cell data is too long to be a date
          data[row][cell].trim().length > longestPlausibleDateLength ||
          // OR the cell contains at least 5 non-numerical, non-space characters
          // first half of expression can safely resolve to null
          // null is treated like a 0 in '<>' expressions
          data[row][cell].trim().match(nonNumericRegex)?.join("")?.length >
            nonNumericCharacterThreshold
        ) {
          cellTracker[row][cell] = false;
          continue;
        }

        // This finds the regex matches within the date
        var dateMatches = dateRegex.exec(data[row][cell]);

        // If there was any matches on the date regex continue and if it split
        // what looks like a proper date then continue. Proper date would look
        // like ["1/2/3", "1", "2", "3"]
        if (dateMatches && dateMatches.length === 4) {
          // If the first group matched is 4 digits it has to be a year
          // followed by month. For example 1990-01-02. We know then it's NOT
          // a euro, day first, date. If it's not 4 but it's larger than 12
          // then we know it's a euro date since there's no months > 12.
          if (dateMatches[1].length !== 4 && dateMatches[1] > 12) {
            // Just because it's >12 and not 4 digits doesn't mean it's a
            // date though. For example, a phone number will trip this up
            // such as 555-555-5555. We need to format it the way we want
            // then parse it and see if it is a valid date. If it is then we
            // know for sure it's a euro date.
            var formattedEuroDate =
              dateMatches[3] + "-" + dateMatches[2] + "-" + dateMatches[1];
            cellTracker[row][cell] = !!BatchGeo.isDate(formattedEuroDate);
          } else {
            // If it's not NOT 4 digits and the first match isn't
            // greater than twelve it doesn't mean it's not a euro date.
            // For example, 1/2/1 could be Jan 2 or Feb 1. In either
            // case both are valid so its indeterminate. The line below
            // will set the tracker to `null` in this case. However, if
            // the parsing fails altogether than it'll be marked false.
            cellTracker[row][cell] = BatchGeo.isDate(dateMatches[0])
              ? null
              : false;
          }
        }
        // If the regex didn't find any matches at all then there's no way it's
        // a date
        else {
          cellTracker[row][cell] = false;
        }
      }
    }

    // We will use to track the row indexes that need to be converted
    var goodIndexes = [];
    // For every *column* (note that we're getting the length of the first row, not
    // the length of the dataset).
    for (let row = 0; row < data[0].length; row++) {
      var columnValues = [];

      // Here we push each column of data into an array. For a visual if you had
      // [
      //   [1,2,3]
      //   [a,b,c]
      // ]
      // This will create:
      // [1, a] then [2, b] and so on
      for (var column = 0; column < data.length; column++) {
        columnValues.push(cellTracker[column][row]);
      }

      // If there was at least one euro date (true) and none of them tripped the
      // false flag then we call it a "good" index and we can convert it.
      if (
        columnValues.indexOf(false) === -1 &&
        columnValues.indexOf(true) > -1
      ) {
        goodIndexes.push(row);
      }
    }

    // For each good index we found we need to convert the dates. We can use forEach
    // here since this is already optimized
    goodIndexes.forEach(function (goodIndex) {
      // We now modify the original dataset
      data.forEach(function (row, rowIndex) {
        // Ignore header
        if (hasHeader && rowIndex === 0) return;
        // Ignore empty rows
        if (row[goodIndex] === "") return;
        // Finally, we can save the converted date
        var dateMatch = dateRegex.exec(row[goodIndex]);
        if (dateMatch)
          data[rowIndex][goodIndex] =
            dateMatch[3] + "-" + dateMatch[2] + "-" + dateMatch[1];
      });
    });

    return data;
  };

  window.BatchGeoEuroDateConverter = BatchGeoEuroDateConverter;
})(window);
